export const gestorDashboardFieldClass =
  'h-10 w-full rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)] px-3 text-sm text-text-primary outline-none transition-colors focus:border-accent/40 focus:ring-1 focus:ring-accent/20'

export const gestorDashboardSearchClass =
  'h-9 w-full rounded-lg border border-[var(--glass-border)] bg-[var(--glass-bg)] py-2 pl-9 pr-8 text-sm text-text-primary placeholder:text-text-muted outline-none transition-colors focus:border-accent/40 focus:ring-1 focus:ring-accent/20'

export const gestorDashboardSectionTitleClass =
  'text-[11px] font-semibold uppercase tracking-[0.08em] text-text-muted'
